import * as React from "react";
import {SVGProps} from "react";
const SvgDefaultBookmaker = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 15 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M0 3.728 3.728 0h4.854c-.516.25-.994.58-1.411.998l-6.12 6.12A4.62 4.62 0 0 1 0 4.172v-.444ZM4.138 15h-.41L0 11.272V6.418c.25.516.581.994.998 1.411l6.12 6.12A4.62 4.62 0 0 1 4.172 15h-.034ZM15 11.272 11.272 15H6.42a5.17 5.17 0 0 0 1.41-.998l6.12-6.12c.68.83 1.051 1.86 1.051 2.946v.444Zm-.998-4.101-6.12-6.12A4.62 4.62 0 0 1 10.829 0h.443L15 3.728V8.58a5.17 5.17 0 0 0-.998-1.41Z" />
    </svg>
);
export default SvgDefaultBookmaker;
